import getValue from './getValue.function'
import moment from 'moment'
const now = () => moment().utc().format('YYYY-MM-DD HH:mm:ss')
const today = () => moment().utc().format('YYYY-MM-DD')

export { getValue, now, today }
